import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormInput from './form-input';
import FormTextArea from './form-textarea';
import FormInputEmail from './form-input-email';
import FormInputDate from './form-input-date';
import FormSelect from './form-select';
import FormCheckbox from './form-checkbox';
import FormInputNumber from './form-input-number';
import FormMultiSelect from './form-multiselect';
import type { ComponentType } from 'react';

interface FormItem {
  title?: string;
  type?: string;
  format?: string;
  [key: string]: unknown;
}

interface FormGroupProps {
  items?: Array<FormItem>;
  col: number;
  layout?: string;
  submitted: boolean;
}

interface FormComponentProps {
  item: FormItem;
  unique: string;
  submitted: boolean;
}

type FormComponentMap = {
  [type: string]: {
    default: ComponentType<FormComponentProps>;
    [format: string]: ComponentType<FormComponentProps>;
  };
};

const formatMap: FormComponentMap = {
  string: {
    default: FormInput as ComponentType<FormComponentProps>,
    enum: FormSelect as ComponentType<FormComponentProps>,
    multiple: FormMultiSelect as ComponentType<FormComponentProps>,
    email: FormInputEmail as ComponentType<FormComponentProps>,
    date: FormInputDate as ComponentType<FormComponentProps>,
    text: FormTextArea as ComponentType<FormComponentProps>,
  },
  boolean: {
    default: FormCheckbox as ComponentType<FormComponentProps>,
  },
  integer: {
    default: FormInputNumber as ComponentType<FormComponentProps>,
  },
};

const FormGroup = ({ items, col, layout, submitted }: FormGroupProps) => {
  const notOneCol = layout !== 'One Column';

  return (
    <Grid
      item
      lg={notOneCol ? (col > 1 ? 6 : false) : false}
      xs={notOneCol ? (col > 1 ? false : 12) : false}
    >
      <Box paddingX={notOneCol ? (col > 1 ? 2 : 0) : 0} my={notOneCol ? 2 : 0}>
        {items
          ? items.map((item) => {
              let RenderedComponent: ComponentType<FormComponentProps> = () => <div />;
              try {
                if (item.type) {
                  const typeMap = formatMap[item.type];
                  RenderedComponent = (item.format && typeMap[item.format]) ? typeMap[item.format] : typeMap.default;
                }
              } catch (e) {
                console.warn('FormGroup:RenderComponent', e, item);
              }
              const itemKey = (item.title ?? '').toLowerCase().replace(/[^\w]/gi, '_');
              return (
                <RenderedComponent
                  item={item}
                  unique={itemKey}
                  key={itemKey}
                  submitted={submitted}
                />
              );
            })
          : null}
      </Box>
    </Grid>
  );
};
export default FormGroup;
